export default "__VITE_ASSET__2222fb23__"